module.exports = {
	apiKey: "AIzaSyBBkePTTUOXpbYUaL3ND6h2RnvJf6MsfSs",
	authDomain: "master-n-masters-246505.firebaseapp.com",
	databaseURL: "https://master-n-masters-246505.firebaseio.com",
  	projectId: "master-n-masters-246505",
	storageBucket: "master-n-masters-246505.appspot.com",
  	messagingSenderId: "175013806621",
  	appId: "1:175013806621:web:11503e9bbb522a0d5abcf4"
};
